<template>
  <soha-modal
    :id="modalId"
    hide-footer
    @show="$emit('show')"
    @hide="$emit('hide')"
  >
    <template #body>
      <div class="row justify-content-center">
        <p class="soha-delete-modal-text">
          {{ text }}
        </p>
      </div>
      <div class="row mt-3 justify-content-center">
        <div class="d-flex">
          <soha-button
            name="acceptDeleteModalBtn"
            :loading="loading"
            class="mr-2"
            variant="danger"
            outline
            :text="deleteBtnText"
            @btn-click="$emit('onDelete')"
          />
          <soha-button
            name="acceptRejectModalBtn"
            class="ml-2"
            :text="$t(`${I18nPrefix}RETURN_BTN_TXT`)"
            @btn-click="$modal.hide(modalId)"
          />
        </div>
      </div>
    </template>
  </soha-modal>
</template>

<script>
import "@/assets/css/components/base/delete-modal.css";
export default {
  name: "DeleteModal",

  props: {
    text: {
      type: String,
      require: true,
      default: null,
    },
    loading: {
      type: Boolean,
      require: true,
    },
    modalId: {
      type: String,
      default: "deleteModal",
    },
    deleteBtnText: {
      type: String,
      default: "بله، حذف شود",
    },
  },

  emits: ['show', 'hide', 'onDelete'],

  data() {
    return {
      I18nPrefix: "COMPONENTS.BASE.DELETE_MODAL.",
    };
  },
};
</script>
